import React from 'react'
import avatar from '../../../assets/images/avatar.png'


const LeaderboardTable = () => {
    return (
        <>
            <div className="leaderboarddata">
                <div className="row">
                    <div className="col-7">
                        <div className='luserdetail d-flex'>
                            <span className='d-flex align-items-center gap-1'><span className='index'>01</span> <img src={avatar} alt="" /> </span>
                            <div>
                                <h6 className='mb-0 font-xss line-height1'><strong>Sunil</strong></h6>
                                <p className='mb-0 font-xss'>sunilyadav@simulanis.com</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-3">
                        <p className='font-xss mb-0'>21354</p>
                    </div>
                    <div className="col-2">
                        <p className='font-xss mb-0'>00:10 sec</p>
                    </div>
                </div>
                <div className="row">
                    <div className="col-7">
                        <div className='luserdetail d-flex'>
                            <span className='d-flex align-items-center gap-1'><span className='index'>02</span> <img src={avatar} alt="" /> </span>
                            <div>
                                <h6 className='mb-0 font-xss line-height1'><strong>Sunil</strong></h6>
                                <p className='mb-0 font-xss'>sunilyadav@simulanis.com</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-3">
                        <p className='font-xss mb-0'>21354</p>
                    </div>
                    <div className="col-2">
                        <p className='font-xss mb-0'>00:10 sec</p>
                    </div>
                </div>
                <div className="row">
                    <div className="col-7">
                        <div className='luserdetail d-flex'>
                            <span className='d-flex align-items-center gap-1'><span className='index'>03</span> <img src={avatar} alt="" /> </span>
                            <div>
                                <h6 className='mb-0 font-xss line-height1'><strong>Sunil</strong></h6>
                                <p className='mb-0 font-xss'>sunilyadav@simulanis.com</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-3">
                        <p className='font-xss mb-0'>21354</p>
                    </div>
                    <div className="col-2">
                        <p className='font-xss mb-0'>00:10 sec</p>
                    </div>
                </div>
                <div className="row">
                    <div className="col-7">
                        <div className='luserdetail d-flex'>
                            <span className='d-flex align-items-center gap-1'><span className='index'>50</span> <img src={avatar} alt="" /> </span>
                            <div>
                                <h6 className='mb-0 font-xss line-height1'><strong>Sunil</strong></h6>
                                <p className='mb-0 font-xss'>sunilyadav@simulanis.com</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-3">
                        <p className='font-xss mb-0'>21354</p>
                    </div>
                    <div className="col-2">
                        <p className='font-xss mb-0'>00:10 sec</p>
                    </div>
                </div>

                <div className="row">
                    <div className="col-7">
                        <div className='luserdetail d-flex'>
                            <span className='d-flex align-items-center gap-1'><span className='index'>04</span> <img src={avatar} alt="" /> </span>
                            <div>
                                <h6 className='mb-0 font-xss line-height1'><strong>Sunil</strong></h6>
                                <p className='mb-0 font-xss'>sunilyadav@simulanis.com</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-3">
                        <p className='font-xss mb-0'>21354</p>
                    </div>
                    <div className="col-2">
                        <p className='font-xss mb-0'>00:10 sec</p>
                    </div>
                </div>
                <div className="row">
                    <div className="col-7">
                        <div className='luserdetail d-flex'>
                            <span className='d-flex align-items-center gap-1'><span className='index'>05</span> <img src={avatar} alt="" /> </span>
                            <div>
                                <h6 className='mb-0 font-xss line-height1'><strong>Sunil</strong></h6>
                                <p className='mb-0 font-xss'>sunilyadav@simulanis.com</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-3">
                        <p className='font-xss mb-0'>21354</p>
                    </div>
                    <div className="col-2">
                        <p className='font-xss mb-0'>00:10 sec</p>
                    </div>
                </div>
            </div>


            {/* <table className='table'>
                            <thead>
                                <tr>
                                    <th>Name</th>
                                    <th>Score</th>
                                    <th>Time</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>
                                        <div className='luserdetail d-flex'>
                                            <span className='d-flex align-items-center gap-1'><span className='index'>1</span> <img src={avatar} alt="" /> </span>
                                            <div>
                                                <h6 className='mb-0 font-xss line-height1'><strong>Sunil</strong></h6>
                                                <p className='mb-0 font-xss'>sunilyadav@simulanis.com</p>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        21354
                                    </td>
                                    <td>
                                        00:10 sec
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <div className='luserdetail d-flex'>
                                            <span className='d-flex align-items-center gap-1'><span>1</span> <img src={avatar} alt="" /> </span>
                                            <div>
                                                <h6 className='mb-0 font-xss line-height1'><strong>Sunil</strong></h6>
                                                <p className='mb-0 font-xss'>sunilyadav@simulanis.com</p>
                                            </div>
                                        </div>
                                    </td>
                                    <td>21354</td>
                                    <td>00:10 sec</td>
                                </tr>
                            </tbody>
                        </table> */}


        </>
    )
}

export default LeaderboardTable
